import React, { Component } from 'react'
import axios from 'axios'

import PlaceHolder from '../../../atoms/PlaceHolder'
import Font from '../../../atoms/Font'
import T from '../../../../SPRINTA/translate/T'
import Carousel, { SlickItem } from '../../../third-party-v2/SlickCarousel'
import ImageLightBox from '../../../third-party/ImageLightBox'

import ItemKit from '../../../molecules/ItemKit'

export default class ListKits extends Component {
    state = {
        status: 'loading',
        data: [],
        images: null,
        lightBox: false,
        indexImageLightBox: 0
    }

    componentWillMount() {
        axios.get('event_kits/list_kits/'+this.props.token+'/0/1000')
        .then(resp => {
            let status = ''
            let data = []
            if(resp.total === 0) {
                status = 'no_content'
            } else {
                status = 'done'
                data = resp.result
            }

            let images = []
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                images.push(item.image_path)
            }

            this.setState({
                status,
                data,
                images
            })
        })
    }

    openImage(index) {
        this.setState({
            indexImageLightBox: index,
            lightBox: true,
        })
    }

    render() {
        if(this.state.status === 'loading')
        return (
            <div>
                <PlaceHolder type='retangle' style={{height:'250px'}} />
            </div>
        )
        
        if(this.state.status === 'no_content')
        return <span />

        if(this.state.status === 'done')
        return (
            <div style={{marginTop: '30px', marginBottom: '30px'}}>
                <Font size='30' weight="100">{ this.state.data.length > 1 ? T.text('kits') : T.text('kit')}</Font>  
                
                {this.state.data.length > 1
                ?
                <Carousel arrowTop='29%' itens={2} arrows={this.state.data.length > 2} dots={this.state.data.length > 2}>
                    {this.state.data.map( (kit, key) => 
                        <SlickItem key={kit.id}>
                            <ItemKit
                                image={kit.image_path}
                                title={kit.name}
                                content={kit.description}
                                handleClick={() => { this.openImage(key) }}
                            />
                        </SlickItem>
                    )}
                </Carousel>
                    
                : <ItemKit
                        title={this.state.data[0].name}
                        image={this.state.data[0].image_path}                        
                        content={this.state.data[0].description}
                        handleClick={() => { this.openImage(0) }}
                        full
                    />
                }
                
                <ImageLightBox handleClose={() => {
                    this.setState({
                        lightBox: false
                    })
                }} isOpen={this.state.lightBox} images={this.state.images} photoIndex={this.state.indexImageLightBox}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Event/ListKits/index.js